import Vue from 'vue';
import Vuex from 'vuex';
import auth from '@/screens/Auth/store';
import emails from '@/screens/Emails/store';
import metrics from '@/screens/Metrics/store';
import locations from '@/screens/Locations/store';
import status from '@/screens/Status/store';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production' || process.env.NODE_ENV !== 'staging';

export default new Vuex.Store({
  modules: {
    auth,
    emails,
    metrics,
    locations,
    status,
  },
  strict: debug,
});



// WEBPACK FOOTER //
// ./src/store.js